import { useContext, useEffect } from 'react'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import SpecsPage from './SpecsPage';
import SeoGeneral from '../BusinessPage/SeoGeneral';

const TechnicalSpecificationPage = () => {
    const colordata = useContext(Colorcontext);
    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const seoMetaData = {
        title: "NeooSearch Technical Specification",
        description: "NeooSearch technical specifications for creatives and business listings.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "NeooSearch – Technical Specification",
        url: process.env.REACT_APP_APPLICATION_URL + "/technical-specification",
        keywords: "NeooSearch, technical specification, creatives, business listings",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/technical-specification"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className='searchloginmain'>
                <div className='cust_container'>
                    <div className='bg-wht'>
                        <div className=''>
                            <SpecsPage />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TechnicalSpecificationPage
